import { Component, inject } from "@angular/core";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import { JwtAuthService } from "@app/shared/services/jwt-auth.service";
import { Router } from "@angular/router";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";

@Component({
    selector: "app-login",
    imports: [SharedMaterialModule, SharedDsnModule, ReactiveFormsModule],
    templateUrl: "./login.component.html",
    styleUrl: "./login.component.scss"
})
export class LoginComponent {
    private readonly router = inject(Router);
    private readonly fb = inject(FormBuilder);
    private readonly jwtAuth = inject(JwtAuthService);

    public loginForm: FormGroup;
    public loading: boolean = false;

    constructor() {
        // this.autoSignin();
        // this.loginForm = this.fb.group({
        //     email: ["", [Validators.required, Validators.email]],
        //     password: ["", [Validators.required, Validators.minLength(6)]]
        // });
        window.location.href = "https://pro.nucont.com/";
    }

    private autoSignin(): void {
        if (this.jwtAuth.isLoggedIn()) {
            this.router.navigateByUrl(this.jwtAuth.return);
        }
    }

    public async onSubmit(): Promise<void> {
        this.loading = true;
        if (this.loginForm.valid) {
            const response = await this.jwtAuth.signin(
                this.loginForm.value.email,
                this.loginForm.value.password
            );
            if (response) {
                this.router.navigateByUrl(this.jwtAuth.return);
            }
        }
        this.loading = false;
    }
}
